module.exports = __webpack_public_path__ + "static/img/05.9374f2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour4/05.jpg
// module id = zCWI
// module chunks = 0